export const BYTES_IN_KiB = 1024;
export const BYTES_IN_MiB = BYTES_IN_KiB * BYTES_IN_KiB;
export const BYTES_IN_GiB = BYTES_IN_MiB * BYTES_IN_KiB;
export const BYTES_IN_TiB = BYTES_IN_GiB * BYTES_IN_KiB;
